import { render, staticRenderFns } from "./HerbalCollection.vue?vue&type=template&id=23a7b613&scoped=true"
import script from "./HerbalCollection.vue?vue&type=script&lang=js"
export * from "./HerbalCollection.vue?vue&type=script&lang=js"
import style0 from "./HerbalCollection.vue?vue&type=style&index=0&id=23a7b613&prod&scoped=true&lang=css"
import style1 from "./HerbalCollection.vue?vue&type=style&index=1&id=23a7b613&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7b613",
  null
  
)

export default component.exports